/**
 * Constraint-strategy registry. A new constraint kind needs: a member in the
 * ConstraintSpec union (../types.ts), a strategy file, and a registration here.
 */

import type { ConstraintSpec } from '../types';
import type { ConstraintStrategy } from './types';
import { freeConstraint } from './FreeConstraint';
import { wallConstraint } from './WallConstraint';

const strategies = new Map<ConstraintSpec['kind'], ConstraintStrategy>([
  [freeConstraint.kind, freeConstraint],
  [wallConstraint.kind, wallConstraint],
]);

export function getConstraintStrategy(kind: ConstraintSpec['kind']): ConstraintStrategy {
  const strategy = strategies.get(kind);
  if (!strategy) throw new Error(`No constraint strategy registered for kind '${kind}'`);
  return strategy;
}
